import {useQuery} from 'react-query';
import getAdLikeStatus from '.';

const useGetAdLikeStatus = (
  guid: string,
  enabled: boolean,
  liking_type: string,
) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['get-offers', guid, liking_type],
    queryFn: () => getAdLikeStatus(guid, {liking_type}),
    enabled: enabled,
  });

  return {adLikeStatusData: data, isLoading, refetch};
};

export default useGetAdLikeStatus;
